import { FilterValues } from '../../../../app/models/filter-values';

export class RawFilterProfile extends FilterValues{
    public months: number[];
    public monthsCode: string;
    public currencySymbol: number;
}
